import { html, unsafeCSS } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { PopBaseComponent } from '../../base/pop-base-component';
import { Constants } from './disclosure.constants';
import style from './disclosure.scss?inline';

/**
 * @tag pop-disclosure-component
 * @slot default - contains disclosure content
 */
@customElement(Constants.TAG_NAME)
export class PopDisclosureComponent extends PopBaseComponent {
  static get styles() {
    return [...super.styles, unsafeCSS(style)];
  }

  /**
   * @internal
   */
  tagName = Constants.TAG_NAME;

  /**
   * Text for the expand/collapse toggle button
   * @type string
   */
  @property({ attribute: Constants.DATA_COLLAPSIBLE_BUTTON_TEXT, type: String })
  collapsibleButtonText?: string;

  /**
   * Whether the disclosure is expanded
   */
  @property({ attribute: Constants.DATA_EXPANDED, type: Boolean })
  dataExpanded? = false;

  /**
   * @internal
   */
  contentSlot;

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this.contentSlot = this.renderRoot.querySelector('slot');
    this.initDisclosure();
  }

  render() {
    let buttonHtml = html``;
    if (this.collapsibleButtonText) {
      const arrow = this.dataExpanded
        ? html`<i class="arrow up"></i>`
        : html`<i class="arrow down"></i>`;
      buttonHtml = html` <button
        @click=${this.toggleDisclosure}
        aria-expanded=${this.dataExpanded}
        class="b-typography-sans-serif--body--100 disclosure-button"
      >
        ${arrow} ${this.collapsibleButtonText}
      </button>`;
    }

    return this.renderComponent(html`
      ${buttonHtml}
      <div class="b-typography-sans-serif--caption--300 disclosure-content">
        <slot></slot>
      </div>
    `);
  }

  initDisclosure() {
    if (!this.collapsibleButtonText) {
      this.dataExpanded = true;
      this.contentSlot.style.display = '';
      return;
    }
    if (this.contentSlot) {
      this.contentSlot.style.display = this.dataExpanded ? '' : 'none';
    }
  }

  toggleDisclosure() {
    this.dataExpanded = !this.dataExpanded;
    if (this.contentSlot) {
      this.contentSlot.style.display = this.dataExpanded ? '' : 'none';
    }
  }
}
